import { render, staticRenderFns } from "./ResourceCreateBasics.vue?vue&type=template&id=a6bf6868&"
import script from "./ResourceCreateBasics.vue?vue&type=script&lang=js&"
export * from "./ResourceCreateBasics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6bf6868')) {
      api.createRecord('a6bf6868', component.options)
    } else {
      api.reload('a6bf6868', component.options)
    }
    module.hot.accept("./ResourceCreateBasics.vue?vue&type=template&id=a6bf6868&", function () {
      api.rerender('a6bf6868', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/steps/ResourceCreateBasics.vue"
export default component.exports